import { Await } from "react-router-dom";
import { PodcastKeywordContext } from "@app/types/Page";
import CustomError from "@components/Error/CustomError";
import { TRouteWithRedirect, useRouteContext } from "@sphtech/web2-core/ssr";
import { HttpStatusCode } from "axios";

import PodcastsKeywordContent from "./PodcastsKeywordContent";

export default function PodcastsPage(): React.ReactElement {
  const { context } =
    useRouteContext<TRouteWithRedirect<PodcastKeywordContext, string>>();

  if (context && context.statusCode !== HttpStatusCode.Ok) {
    // StatusCode is not 200
    return <CustomError statusCode={context.statusCode} />;
  }

  return (
    <Await resolve={context.payload} errorElement={<CustomError />}>
      {({ kind, data }: PodcastKeywordContext) => {
        if (kind === "keyword") {
          return <PodcastsKeywordContent data={data} />;
        }

        // Default error page.
        return <CustomError statusCode={HttpStatusCode.NotFound} />;
      }}
    </Await>
  );
}
